import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable, Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { CustomMessageService } from '@core/services';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private messageService: CustomMessageService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    var showLoading = request.params.get('SHOW-LOADING');

    if (showLoading != 'false') {
      this.messageService.showModalLoading();
      const loadingSubscription: Subscription =
        this.messageService.spinner$.subscribe();
      return next
        .handle(request)
        .pipe(finalize(() => loadingSubscription.unsubscribe()));
    } else {
      return next.handle(request);
    }
  }
}
